/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Dokončeno`
};

const da_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Afsluttet`
};

const de_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Abgeschlossen`
};

const en_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Complete`
};

const es_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Completado`
};

const fr_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Terminé`
};

const hu_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Befejezve`
};

const it_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Completato`
};

const nl_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Voltooid`
};

const pl_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Zakończone`
};

const pt_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Concluído`
};

const sv_order_states_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Slutförd`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_states_complete = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_states_complete(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_states_complete", locale)
	if (locale === "cs") return cs_order_states_complete(inputs)
	if (locale === "da") return da_order_states_complete(inputs)
	if (locale === "de") return de_order_states_complete(inputs)
	if (locale === "en") return en_order_states_complete(inputs)
	if (locale === "es") return es_order_states_complete(inputs)
	if (locale === "fr") return fr_order_states_complete(inputs)
	if (locale === "hu") return hu_order_states_complete(inputs)
	if (locale === "it") return it_order_states_complete(inputs)
	if (locale === "nl") return nl_order_states_complete(inputs)
	if (locale === "pl") return pl_order_states_complete(inputs)
	if (locale === "pt") return pt_order_states_complete(inputs)
	return sv_order_states_complete(inputs)
};
export { order_states_complete as "order_states.complete" }